/**
 * This component render only for merchandise only
 */

import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import { DetailsSectionDivider } from "../DetailsSectionDivider";
import { Variant } from "./components/HelperComponents";
import { IVariantSelector } from "./IVariantSelector";
import useVariantSelector from "./utils/useVariantSelector";
import styles from "./variantSelector.module.scss";

const VariantSelector: FC<IVariantSelector.IProps> = props => {
    const { className, showBottonDivider } = props;
    const {
        hideComponent,
        variantOptions,
        handleClick,
        isSelected,
        itemNotAvailable,
        isOutOfStock,
        showHurryUp,
    } = useVariantSelector();

    if (hideComponent) return null;

    return (
        <>
            <div className={classNames(styles.root, className)}>
                {variantOptions.map(option => (
                    <Variant
                        key={option.type}
                        variantOption={option}
                        onClick={handleClick}
                        isSelected={isSelected}
                    />
                ))}
            </div>

            {(itemNotAvailable || isOutOfStock || showHurryUp) && (
                <div className={styles.notAvailable}>
                    {itemNotAvailable ? "Item is not available." : null}
                    {isOutOfStock ? "Sorry :( Item out of stock" : null}
                    {showHurryUp ? "Hurry Up!! Only few left" : null}
                </div>
            )}

            {showBottonDivider && <DetailsSectionDivider />}
        </>
    );
};

export default VariantSelector;
